module.exports = __webpack_public_path__ + "assets/img/2.c8463710.webp";